import { defineNuxtPlugin, useHead, useRuntimeConfig } from "#imports";


export default defineNuxtPlugin(nuxtApp => {
	if (process.client) {
		const runtimeConfig = useRuntimeConfig();
		const appEnv = runtimeConfig.appEnv;
		if (appEnv !== 'prod') {
			useHead(
				{
					meta: [
						{ hid: 'robots', name: 'robots', content: 'noindex' }
					]
				}
			);
		}
	}
});
